import './App.css';
import { BrowserRouter as Router, Route } from 'react-router-dom';

import Main from './components/Main';

import Footer from './components/Footer';

function App() {
  return (
    <Router>
      <Main />          
      <Footer />
    </Router>
  );
}

export default App;
